<template>
    <div class="card">
        <div class="card-header">
            <h5>工作日设置</h5>
        </div>
        <div class="card-body" v-loading="loading">
            <div class="left">
                <el-form>
                    <el-form-item>
                        <el-date-picker
                                v-model="rang.year"
                                value-format="yyyy"
                                type="year"
                                style="width: 100%"
                                placeholder="选择年"
                                @change="handleTemplateDays">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="rang.semester_type_id" placeholder="请选择" @change="handleTemplateDays">
                            <el-option
                                    v-for="item in semesterTypes"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="rang.semester_id" clearable placeholder="请选择" @change="handleTemplateDays">
                            <el-option
                                    v-for="item in semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div style="max-height:400px;position: relative;overflow: auto;overflow-y:scroll">
                            <div v-for="(item,key) in templateDays" @click="handleChooseTemplateDay(item)"
                                 class="template-day">
                                <span class="circle" :class="{'active':item.id==chosenTemplateDay.id}"></span>
                                <el-tag class="day-tag" :style="{'background':item.color,'border-color':item.color}" >
                                    {{item.name}}
                                </el-tag>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-popover
                                placement="right"
                                width="300"
                                v-model="formVisible">
                            <el-form ref="form" :inline="true" label-position="top" label-width="80px">
                                <el-form-item label="工作日名称">
                                    <el-input v-model="templateName"></el-input>
                                </el-form-item>
                                <el-form-item label="时间段">
                                    <el-select v-model="timeQuantums_id" multiple placeholder="请选择">
                                        <el-option
                                                v-for="item in timeQuantums"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="颜色">
                                    <el-color-picker
                                            v-model="color"
                                            :predefine="predefineColors">
                                    </el-color-picker>
                                </el-form-item>
                            </el-form>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="formVisible = false">取消</el-button>
                                <el-button type="primary" size="mini" @click="handleCreateTemplate">确定</el-button>
                            </div>
                            <el-button slot="reference" style="width: 100%">添加模板</el-button>
                        </el-popover>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="width: 100%" @click="handleSaveTemplateDate">保存数据</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="width: 100%" @click="handleGiveTemplateToSemester">赋予学期模板</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <div class="box" v-for="i in 12">
                    <calendar :date="rang.year+'-'+i"></calendar>
                </div>
                <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
        </div>
    </div>
</template>

<script>

    import Calendar from './Calendar'
    export default {
        data() {
            return {
                path: '/workSchedule',
                rang: {
                    year: '2019',
                    semester_type_id:'',
                    semester_id:''
                },
                formVisible: false,
                loading:false,
                predefineColors: [
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#1e90ff',
                    '#c71585'
                ],
                semester_id:'',
                semesters:[],
                timeQuantums:[],
                timeQuantums_id:[],
                chosenTemplateDay: {},
                templateDays: [],
                chosenData: {},
                templateName:'',
                color:'',
                semesterTypes:[],
                dialog_GiveTemplateToSemester:{
                    semesters:[],
                    template_days:[],
                    button_loading:false,
                }
            }
        },
        components: {
            'calendar': Calendar
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleTemplateDays();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semesterTypes = data.semesterTypes;
                        this.timeQuantums = data.timeQuantums;
                        break;
                    case 'get_template_days':
                        if (Object.keys(data.template_days).length !== 0) {
                            this.templateDays = data.template_days;
                        } else {
                            this.templateDays = new Object();
                        }
                        if (Object.keys(data.template_dates).length !== 0) {
                            this.chosenData=data.template_dates;
                        } else {
                            this.chosenData = new Object();
                        }
                        this.semesters = data.semesters;
                        this.loading=false
                        break;
                    case 'create_template_day':
                        this.$set(this.templateDays,data.template_day.id,data.template_day)
                        this.templateName=''
                        this.color=''
                        this.timeQuantums_id=''
                        this.formVisible = false
                        break;
                    case 'store_template_date':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.loading=false;
                        break;
                    case 'store_template_date_error':
                        this.loading=false;
                        break;
                    case 'get_template_and_semester':
                        this.dialog_GiveTemplateToSemester.semesters=data.semesters
                        this.dialog_GiveTemplateToSemester.template_days=data.template_days
                        break;
                    case 'give_template_to_semester':
                        this.$message({
                            message: '赋予成功',
                            type: 'success'
                        });
                        this.dialog_GiveTemplateToSemester.button_loading=false;
                        this.$Win.closeModal();
                        break;

                }
            },
            handleInit(){
                this.$wApi.send(this.path, 'init', {});
            },
            handleTemplateDays() {
                this.$wApi.send(this.path, 'get_template_days',
                    {
                        'year':this.rang.year,
                        'semester_type_id':this.rang.semester_type_id,
                        'semester_id':this.rang.semester_id,
                    });
            },
            handleChooseTemplateDay(item) {
                this.chosenTemplateDay = item
            },
            handleCreateTemplate(){
                this.$wApi.send(this.path, 'create_template_day',
                    {
                        'templateName':this.templateName,
                        'semester_type_id':this.rang.semester_type_id,
                        'semester_id':this.rang.semester_id,
                        'color':this.color,
                        'timeQuantums_id':this.timeQuantums_id
                    });
            },
            handleSaveTemplateDate(){
                this.$confirm('确认保存?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading=true;
                    this.$wApi.send(this.path, 'store_template_date',
                        {
                            'chosenData':this.chosenData,
                            'semester_id':this.rang.semester_id,
                            'semester_type_id':this.rang.semester_type_id
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleGiveTemplateToSemester(){
                this.$Win.openModal('Dialog_GiveTemplateToSemester', 350, 400, '赋予学期模板');
            }
        }
    }
</script>

<style scoped lang="scss">
    .template-day {
        .circle {
            &.active {
                opacity: 1;
            }
            opacity: 0;
            float: left;
            display: block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(103, 194, 58, 1);
            border: 1px solid rgba(103, 194, 58, .2);
            color: #67c23a;
            margin: 6px 5px;
        }

        .day-tag {
            color: #fff;
            cursor: pointer;
            margin-bottom: 10px;
        }
    }

    .left {
        width: 120px;
        float: left;
    }

    .line {
        border-left: 1px solid rgba(234, 243, 253, 0.9);
        width: 1px;
        height: 90%;
        position: absolute;
        left: 150px;
    }

    .right {
        margin-left: 130px;
        .box {
            float: left;
            margin: 15px;
        }
    }
</style>
